import { render } from "./manage_role.vue?vue&type=template&id=cb34ec96"
import script from "./manage_role.vue?vue&type=script&lang=js"
export * from "./manage_role.vue?vue&type=script&lang=js"

import "./manage_role.vue?vue&type=style&index=0&id=cb34ec96&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__